import merge from 'lodash/merge';

const getDefaultState = () => ({
  allIds: [],
  byId: {}
});

const state = getDefaultState();

const getters = {
  find: (state, getters) => id => ({
    ...state.byId[id],
    parent: getters.getParent(id)
  }),
  list: (state, getters) => state.allIds.map(id => getters.find(id)),
  parentId: (state, getters, rootState) => id =>
    rootState.cart.cartProducts.allIds.find(productId =>
      rootState.cart.cartProducts.byId[productId]?.order_products?.includes(id)
    ),
  getParent: (state, getters, rootState) => id => {
    const parentId = getters.parentId(id);
    return rootState.cart.cartProducts.byId[parentId];
  }
};

const actions = {
  addOrderProducts: ({ commit }, orderProducts) => {
    orderProducts.forEach(op => {
      commit('add', op);
    });
  },
  removeOrderProducts: ({ commit }, ids) => commit('remove', ids)
};

const mutations = {
  add: (state, orderProduct) => {
    state.byId[orderProduct.id] = orderProduct;
    if (state.allIds.includes(orderProduct.id)) return;
    state.allIds.push(orderProduct.id);
  },
  remove: (state, ids) => {
    // Supports single or an array of ids
    const orderProductIds = Array.isArray(ids) ? ids : [ids];
    orderProductIds.forEach(id => {
      state.allIds.splice(state.allIds.indexOf(id), 1);
      delete state.byId[id];
    });
  },
  reset: state => Object.assign(state, getDefaultState()),
  update: (state, orderProduct) => {
    const merged = merge(state.byId[orderProduct.id], orderProduct);
    state.byId[orderProduct.id] = merged;
  }
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
